import React, { useEffect, useMemo, useRef, useState } from "react";
import { Grid, Typography, Box, Card, CardContent } from "@mui/material";
import {
  AccountCircle,
  Email,
  Phone,
  LocationOn,
  Home,
  Public,
  CreditCard,
  AssignmentInd
} from "@mui/icons-material";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../styles/UserStyles.css";
import { CUSTOMERS } from "../../component/common/Routes/AppRoutes";
import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import CustomButton from "../../component/ui/FormFields/Button";
import {
  fetchCustomerDetailsRequest,
  resetCustomerState,
  updateCustomerRequest
} from "../../redux/Customers/actions/customerActions";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest
} from "../../redux/Common/selectorAction";
import Loading from "../../component/ui/Loading";
import { VENDOR_CUSTOMERS } from "../../component/common/Routes/VendorRoutes";
import GenderRadioGroup from "../../component/ui/FormFields/GenderRadioGroup";
export default function UpdateCustomer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customerId } = useParams();
  const {
    data: customerData,
    loading,
    updateLoading
  } = useSelector((state) => state.customers.customerDetails);
  const viewLoading = loading;
  const editLoading = updateLoading;
  const success = useSelector(
    (state) => state.customers.success?.update || false
  );
  const user = useSelector((state) => state.auth.user);
  const error = useSelector((state) => state.customers.customers.error);
  const {
    control,
    handleSubmit,
    reset,
    setError,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      display_name: "",
      email: "",
      phone: "",
      street: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      nationality: "",
      gender: "",
      dob: "",
      passport_number: "",
      aadhar_number: ""
    }
  });
  useEffect(() => {
    if (customerId) {
      dispatch(resetCustomerState());
      dispatch(fetchCustomerDetailsRequest(customerId));
      dispatch(selectCountryRequest());
    }
  }, [dispatch, customerId]);

  let status = customerData?.status === 0 ? "Active" : "Inactive";
  useEffect(() => {
    if (customerData) {
      reset({
        first_name: customerData.data.first_name,
        last_name: customerData.data.last_name,
        display_name: customerData.data.display_name,
        email: customerData.data.email,
        phone: customerData.data.phone,
        address1: customerData.data.address1,
        address2: customerData.data.address2,
        nationality: customerData.data?.familyMember?.nationality,
        gender_type: customerData.data?.familyMember?.gender_type,
        dob: customerData.data?.familyMember?.dob,
        passport_number: customerData.data?.familyMember?.passport_number,
        aadhar_number: customerData.data?.familyMember?.aadhar_number,
        country_code: customerData.data
          ? {
              label: customerData.data?.country_code,
              value: customerData.data?.country_code
            }
          : null,
        city: customerData.data?.city
          ? {
              label: customerData.data?.city_name.replace("_", " "),
              value: customerData.data?.city
            }
          : null,
        state: customerData.data.state
          ? {
              label: customerData.data.state_name.replace("_", " "),
              value: customerData.data.state
            }
          : null,
        country: customerData.data.country
          ? {
              label: customerData.data.country_name.replace("_", " "),
              value: customerData.data.country
            }
          : null,
        pincode: customerData.data.pincode,
        user_id: customerData.data.user_id,
        user_type: "3",
        status: customerData.data.status === 0 ? "Active" : "Inactive",
        profile_url: customerData.data.profile_url
      });
    }
  }, [customerData, reset]);
  const onSubmit = (data) => {
    const formattedData = {
      ...data,
      city: data.city?.value || data.city,
      state: data.state?.value || data.state,
      country: data.country?.value || data.country,
      user_id: customerData?.data?.user_id,
      profile_url: "null",
      country_code: data?.country_code.value,
      status: data.status === "Active" ? "0" : "1",
      id: customerData?.data?.id
    };
    dispatch(updateCustomerRequest(formattedData, customerId));
  };
  useEffect(() => {
    if (success) {
      toast.success("Customer updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          if (user.role === "Vendor") {
            navigate(VENDOR_CUSTOMERS);
          } else {
            navigate(CUSTOMERS);
          }
        }
      });
    }
  }, [success]);
  //Address selecotor
  const formValue = watch();
  const countryId = formValue.country?.value;
  const stateId = formValue.state?.value;
  const countries = useSelector((state) => state.selector?.country?.data);
  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);
  // country code fetcher
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode
    };
  });
  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });
  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });
  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });
  const stateCount = useRef(0);
  const cityCount = useRef(0);
  useMemo(() => {
    if (countryId > 0 && stateCount.current > 0) {
      setValue("state", "");
      setValue("city", "");
    }
    if (countryId > 0) {
      dispatch(selectStateRequest(countryId));
      stateCount.current += 1;
    }
  }, [countryId]);
  // change state
  useMemo(() => {
    if (stateId > 0 && cityCount.current > 0) {
      setValue("city", "");
    }
    if (stateId > 0) {
      dispatch(selectCityRequest(stateId));
      cityCount.current += 1;
    }
  }, [stateId]);
  useEffect(() => {
    if (error) {
      if (error.message === "An error occurred while updating Customer") {
        toast.error("An error occured while updating Customer!", {
          autoClose: 3000,
          position: "top-center"
        });
      }
      if (error.message === "email must be unique") {
        setError("email", {
          type: "server",
          message: "Email must be unique"
        });
      }
      if (error.message === "contact must be unique") {
        setError("phone", {
          type: "server",
          message: "Contact must be unique"
        });
      }
    }
  }, [error]);
  const customerField = [
    {
      name: "first_name",
      label: "First Name *",
      placeholder: "Enter First Name",
      rules: { required: "First Name is required" },
      icon: <AccountCircle />,
      sm: 6,
      xs: 12
    },
    {
      name: "last_name",
      label: "Last Name *",
      placeholder: "Enter Last Name",
      rules: { required: "Last Name is required" },
      icon: <AccountCircle />,
      sm: 6,
      xs: 12
    },
    {
      name: "email",
      label: "Email *",
      placeholder: "Enter Email Address",
      rules: {
        required: "Email Address is required",
        pattern: {
          value: /^\S+@\S+\.\S+$/,
          message: "Enter a valid email address"
        }
      },
      sm: 6,
      xs: 12,
      icon: <Email />
    },
    {
      name: "country_code",
      options: countryForCode,
      label: "country code *",
      placeholder: "Select Country Code",
      rules: {
        required: "Code is Required"
      },
      sm: 2,
      xs: 4
    },
    {
      name: "phone",
      label: "Mobile Number *",
      placeholder: "Enter Mobile Number",
      type: "Number",
      rules: {
        required: "Mobile Number is required",
        pattern: {
          value: /^\d+$/,
          message: "Enter only numeric digits"
        }
      },
      icon: <Phone />,
      sm: 4,
      xs: 8
    },
    {
      name: "nationality",
      label: "Nationality *",
      placeholder: "Enter Nationality",
      type: "text",
      rules: {
        required: "Nationality is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed"
        }
      },
      xs: 12,
      sm: 6,
      inputProps: {
        onInput: (e) => {
          e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
        }
      }
    },

    {
      name: "dob",
      label: "Date of Birth *",
      placeholder: "Select date of birth",
      type: "dob",
      rules: { required: "Date of Birth is required" },
      xs: 12,
      sm: 6
    },
    {
      name: "address1",
      label: "Address1 *",
      placeholder: "Enter Address",
      rules: { required: "Address is required" },
      icon: <Home />,
      sm: 6,
      xs: 12
    },
    {
      name: "address2",
      label: "Address2 *",
      placeholder: "Enter Address",
      rules: { required: "Address is required" },
      icon: <Home />,
      sm: 6,
      xs: 12
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Select Country",
      type: "text",
      icon: <LocationOn />,
      rules: { required: "Country is required" },
      options: countryName,
      sm: 6,
      xs: 12
    },
    {
      name: "state",
      label: "State",
      placeholder: "Select State",
      type: "text",
      icon: <LocationOn />,
      rules: { required: "State is required" },
      options: stateName,
      sm: 6,
      xs: 8
    },
    {
      name: "city",
      label: "City",
      placeholder: "Select City",
      type: "text",
      icon: <LocationOn />,
      rules: { required: "City is required" },
      options: cityName,
      sm: 6,
      xs: 12
    },
    {
      name: "pincode",
      label: "Pincode",
      placeholder: "Enter Pincode",
      type: "Number",
      icon: <LocationOn />,
      rules: {
        required: "Pincode is required",
        pattern: {
          value: /^[0-9]+$/,
          message: "Enter a valid numeric pincode"
        }
      },
      sm: 6,
      xs: 12
    },
    {
      name: "passport_number",
      label: "Passport Number *",
      placeholder: "Enter Passport Number",
      rules: {
        pattern: {
          value: /^[A-Z][0-9]{6,8}$/,
          message: "Passport Number should be in the format A1234567"
        }
      },
      xs: 12,
      sm: 6
    },
    {
      name: "aadhar_number",
      label: "Aadhar Number",
      placeholder: "Enter Aadhar Number",
      type: "Number",
      rules: {
        pattern: {
          value: /^\d{12}$/,
          message: "Aadhar Number must be exactly 12 digits"
        }
      },
      xs: 12,
      sm: 6
    },
    {
      name: "gender_type",
      label: "Gender",
      placeholder: "Select Gender",
      icon: <AssignmentInd />,
      type: "radio",
      radioOptions: [
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
        { value: "O", label: "Other" }
      ],
      rules: { required: "Gender is required" },
      sm: 6,
      xs: 12
    }
  ];
  if (viewLoading) {
    return <Loading text="Loading customer details..." />;
  }
  return (
    <>
      <ToastContainer />
      <Box className="container">
        <Card>
          <CardContent className="card">
            <Typography variant="h5" className="form-heading">
              Edit Customer
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                container
                rowSpacing={4}
                columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
                className="customer-form-margin"
              >
                {customerField.map((field) => (
                  <Grid item xs={field.xs} sm={field.sm} key={field.name}>
                    <ControlledTextInputField
                      name={field.name}
                      control={control}
                      label={field.label}
                      options={field.options}
                      type={field.type}
                      placeholder={field.placeholder}
                      startAdornment={field.icon}
                      radioOptions={field.radioOptions}
                      rules={field.rules}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]?.message}
                    />
                  </Grid>
                ))}
                <Grid item xs={12} sm={6}>
                  <StatusRadioGroup
                    name="status"
                    control={control}
                    defaultValue={status}
                    rules={{ required: "Status is required" }}
                  />
                </Grid>
              </Grid>
              {/* Buttons */}
              <Grid item xs={12}>
                <Box className="button-container">
                  <CustomButton
                    variant="contained"
                    className="cancel-button"
                    type="button"
                    text={"Back"}
                    onClick={() => navigate(-1)}
                  />
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    type="submit"
                    loading={editLoading}
                    text={"update"}
                  />
                </Box>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
